<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body row-align">

                <div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2">
                  <div class="btn-group enrollment-list-btn-info" role="group">
                    <button type="button" *ngFor="let status of statusList" class="btn"
                      [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                      (click)="activeLeadsTab(status?.name)">{{status.displayname}}</button>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 ">
                  <div class="row-flex">
                    <div *ngIf="currentUrl ==='training-leads'">
                      <button class="btn btn-outline-primary move-to-button" [ngClass]="{'btn-primary':isDumpData,'btn-outline-primary':!isDumpData}"
                        (click)="monthYearWiseDump()">Load Dump</button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-outline-primary move-to-button"  *ngIf="activeTab !=='closed'" (click)="currentStatusToClose()">Move To Close</button>
                      <button class="btn btn-outline-primary" *ngIf=" currentUrl !=='training-leads' && activeTab =='closed'" (click)="deleteOutsourceLeadByCloseStatus()">Delete</button>
                    
                    </div>
                    <div class="col-flex-2 mb-1" *ngIf="currentUrl !=='training-leads'">
                        <!-- <ng-select  [items]="technology_List" bindLabel="displayname" bindValue="_id"
                        placeholder="Select Technology" [(ngModel)]="selectedTechnology"
                        [ngModelOptions]="{ standalone: true }" (change)="getTechnologyId($event)">
                      </ng-select> -->
                      <!-- <div class="btn  btn-block users-list-clear glow mb-0" mat-button [matMenuTriggerFor]="menu"
                       >{{selectedTechnology}}</div>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item *ngFor="let item of technology_List" (click)="getTechnologyId(item?._id,item?.displayname)">{{item.displayname}}</button>
                      </mat-menu> -->
                         
                              <!-- <div ngbDropdown>
                                <button class="btn btn-outline-primary mr-1" id="dropdownBasic1" ngbDropdownToggle>
                                  {{selectedTechnology}}</button>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                  <button class="dropdown-item" *ngFor="let item of technology_List" (click)="getTechnologyId(item?._id,item?.displayname)">{{item.displayname}}</button>
                                </div>
                              </div> -->
                              <div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
                                <button type="button" class="btn btn-outline-primary btn1">{{selectedTechnology}}</button>
                                <button type="button" class="btn btn-outline-primary dropdown-toggle" ngbDropdownToggle
                                  aria-haspopup="true" aria-expanded="false">
                                  <span class="sr-only">Toggle Dropdown</span>
                                </button>
                                <div ngbDropdownMenu class="dropdown-menu" role="menu">
                                  <button class="dropdown-item" *ngFor="let item of technology_List" (click)="getTechnologyId(item?._id,item?.displayname)">{{item.displayname}}</button>
                                </div>
                              </div>
                          
                    </div>


                    <div class="col-flex-2 mb-1 position-relative">
                      <input id="ngx-filter-ref" autocomplete="off"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" placeholder="Search" (keydown.enter)="getLeadsFilter($event.target.value)" #name />
                      <button class="btn search-btn glow position-absolute" (click)="getLeadsFilter(name.value)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button *ngIf="currentUrl ==='training-leads'" type="reset"
                        class="btn btn-primary btn-block users-list-clear glow mb-0" routerLink="/leads/add"
                        placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button *ngIf="currentUrl !=='training-leads'" type="reset"
                        class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/leads/add-outsource-lead" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div> 
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                  [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [rowClass]="getRowClass"
                  [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
                  (page)="pageChangeData($event)">
                    <ngx-datatable-footer>
                      <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize">
                        <div class="datatable-footer-inner">
                          <div class="total-count">
                            <span>Total : {{page.totalPages}} <span *ngIf="activeTab !=='open'"> &nbsp;<span
                                  id="hot-color" *ngIf="activeTab =='active'">Hot : {{count_h}}</span>&nbsp; <span
                                  id="nurture-color" *ngIf="activeTab =='active'">Nurture : {{count_n}} </span>&nbsp;
                                <span id="lost-color" *ngIf="activeTab !=='active' && activeTab !=='open' "><span
                                    id="won-color">Won : {{count_w}} &nbsp;</span> Lost : {{count_l}}</span>
                              </span></span>
                          </div>
                        </div>
                      </ng-template>
                    </ngx-datatable-footer>
                  </ngx-datatable>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-3">
                      <button *ngIf="guideline_data && currentUrl ==='training-leads'" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Training Guideline</button>
                    </div>
                    <div class="col-3" *ngIf="currentUrl ==='training-leads'">
                      <label for="file-upload" class="btn btn-primary btn-block users-list-clear glow mb-0">Upload file</label>
                      <input type="file" accept=".xlsx" id="file-upload" (change)="onSelectFileCSV($event)"/>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button *ngIf="guideline_data && currentUrl !=='training-leads'" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Outsourcing Guideline</button>
                </div>
              </div>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap table-css" [columnMode]="ColumnMode.force" [headerHeight]="40"
              [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [rowClass]="getRowClass"
              [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
              (page)="pageChangeData($event)">
              <ngx-datatable-column name="Lead Name" prop="title" [width]="300">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center" *ngIf="currentUrl ==='training-leads'">
                    
                    <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                      <div class="avatar-content">{{ row?.contact_id?.name || row?.user?.name | shortName }}</div>
                    </div>
                    <div class="cell-line-height cursor-pointer" [routerLink]="['/leads/view', row._id]">
                      <p class="font-medium-1 line-height- mb-0" placement="top"
                        [ngbTooltip]="row?.source?.displayname">
                        {{ row?.contact_id?.name || row?.user?.name }}
                      </p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center" *ngIf="currentUrl !=='training-leads'">
                    <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                      <div class="avatar-content">{{ row?.leads?.title | shortName }}</div>
                    </div>
                    <div class="cell-line-height cursor-pointer" [routerLink]="['/leads/outsource-lead-view', row._id]">
                      <p class="font-medium-1 line-height-1 mb-0" placement="top" [ngbTooltip]=" row?.notes">
                        {{ row?.leads?.title }}
                      </p>
                    </div>
                    
                  </div>
                  <div >
                    <span *ngIf="row?.leads?.created_by?.name" class="badge badge-pill text-capitalize ng-star-inserted bg-light-secondary">
                      {{row?.leads?.created_by?.name}}
                    </span>
                    <span *ngIf="row?.assign_to" >
                      <span *ngFor="let item of row?.assign_to">
                        <span placement="top" ngbTooltip="Farming By" class="badge bg-light-primary mx-1 my-1">{{item?.name}}</span>
                      </span>
                    </span>
                    
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl ==='training-leads'" name="Date" prop="created_at" [width]="30">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span *ngIf="!row?.next_action_date">
                    <p *ngIf="row?.created_at === row?.updated_at">{{row?.created_at | date:'mediumDate'}}</p>
                    <p *ngIf="row?.created_at < row?.updated_at">{{row?.updated_at | date:'mediumDate'}}</p>
                  </span>
                  
                  <span *ngIf="row?.next_action_date">{{row?.next_action_date | date:'mediumDate'}}</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl !=='training-leads'" name="Date" prop="updated_at" [width]="30">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <p *ngIf="row?.created_at === row?.updated_at">{{row?.created_at | date:'mediumDate'}}</p>
                  <p *ngIf="row?.created_at < row?.updated_at">{{row?.updated_at | date:'mediumDate'}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Notes" prop="notes" [width]="120" *ngIf="currentUrl ==='training-leads'">
                <ng-template let-row="row" ngx-datatable-cell-template>

                  <div class="email-detail">
                    <p *ngIf="row?.notes">{{row?.notes |slice :0:100}}...</p>
                  </div>

                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl ==='training-leads'" name="Phone" prop="phone" [width]="60">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <p>{{row?.contact_id?.phone ||  row?.user?.phone}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl !=='training-leads'" name="Date" prop="date" [width]="60">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <p placement="top" [ngbTooltip]="'Last Modified By  ' + row?.leads?.last_updatedby?.name">{{row?.date
                    |
                    date:'mediumDate'}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl !=='training-leads'" name="Technology " prop="technology "
                [width]="60">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <p placement="top" [ngbTooltip]="row?.leads?.lastresponse">{{row?.technology?.displayname}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl !=='training-leads'" name="Channel" prop="channel" [width]="60">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <p placement="top" [ngbTooltip]="row?.leads?.source?.displayname">{{row?.channelId?.name}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl ==='training-leads'" name="Lead Stage" prop="lead_stage"
                [width]="50">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span *ngIf="row?.stage">{{row?.stage?.displayname}}</span>
                  <span *ngIf="row?.lead_status?.name=='active'||row?.lead_status?.name=='closed';else lead_status"
                    placement="top" [ngbTooltip]="row?.last_activedate|date:'mediumDate'"
                    [matMenuTriggerFor]="lead_stagemenu">
                    <!-- {{row?.lead_stage?.displayname}} -->
                    <span [ngClass]="{'bg-light-primary badge badge-pill':row?.lead_stage?.displayname == 'Hot'}"
                      placement="top" [ngbTooltip]="row?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.lead_stage?.displayname == 'Hot'">{{row?.lead_stage?.displayname}}</span>
                    <span [ngClass]="{'bg-light-success badge badge-pill':row?.lead_stage?.displayname == 'Nurture'}"
                      placement="top" [ngbTooltip]="row?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.lead_stage?.displayname == 'Nurture'">{{row?.lead_stage?.displayname}}</span>
                    <span [ngClass]="{'bg-light-success badge badge-pill':row?.lead_stage?.displayname == 'Won'}"
                      placement="top" [ngbTooltip]="row?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.lead_stage?.displayname == 'Won'">{{row?.lead_stage?.displayname}}</span>
                    <span [ngClass]="{'bg-light-danger badge badge-pill':row?.lead_stage?.displayname == 'Lost'}"
                      placement="top" [ngbTooltip]="row?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.lead_stage?.displayname == 'Lost'">{{row?.lead_stage?.displayname}}</span>
                    <span
                      *ngIf="row?.lead_stage?.displayname !== 'Hot' && row?.lead_stage?.displayname !== 'Nurture' && row?.lead_stage?.displayname !== 'Won' && row?.lead_stage?.displayname !== 'Lost'"
                      placement="top"
                      [ngbTooltip]="row?.last_activedate|date:'mediumDate'">{{row?.lead_stage?.displayname}}</span>
                  </span>

                  <ng-template #lead_status>
                    <span [ngClass]="{'bg-light-primary badge badge-pill':row?.lead_stage?.displayname == 'Hot'}"
                      placement="top" [ngbTooltip]="row?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.lead_stage?.displayname == 'Hot'">{{row?.lead_stage?.displayname}}</span>
                    <span [ngClass]="{'bg-light-success badge badge-pill':row?.lead_stage?.displayname == 'Nurture'}"
                      placement="top" [ngbTooltip]="row?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.lead_stage?.displayname == 'Nurture'">{{row?.lead_stage?.displayname}}</span>
                    <span [ngClass]="{'bg-light-success badge badge-pill':row?.lead_stage?.displayname == 'Won'}"
                      placement="top" [ngbTooltip]="row?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.lead_stage?.displayname == 'Won'">{{row?.lead_stage?.displayname}}</span>
                    <span [ngClass]="{'bg-light-danger badge badge-pill':row?.lead_stage?.displayname == 'Lost'}"
                      placement="top" [ngbTooltip]="row?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.lead_stage?.displayname == 'Lost'">{{row?.lead_stage?.displayname}}</span>
                    <span
                      *ngIf="row?.lead_stage?.displayname !== 'Hot' && row?.lead_stage?.displayname !== 'Nurture' && row?.lead_stage?.displayname !== 'Won' && row?.lead_stage?.displayname !== 'Lost'"
                      placement="top"
                      [ngbTooltip]="row?.last_activedate|date:'mediumDate'">{{row?.lead_stage?.displayname}}</span>
                  </ng-template>
                  <mat-menu #lead_stagemenu="matMenu">

                    <div *ngIf="row?.lead_status?.name=='active';else closed ">
                      <div *ngFor="let stage of stageList">
                        <button mat-menu-item *ngIf="stage.name=='nurture' || stage.name=='hot'"
                          (click)="updateLeadStage(row._id,stage._id)">
                          <span>
                            <span [ngClass]="{'bg-light-success badge badge-pill':stage.displayname == 'Nurture'}"
                              placement="top" *ngIf="stage.displayname == 'Nurture'">{{stage.displayname}}</span>
                            <span [ngClass]="{'bg-light-primary badge badge-pill':stage.displayname == 'Hot'}"
                              placement="top" *ngIf="stage.displayname == 'Hot'">{{stage.displayname}}</span>
                          </span>
                        </button>
                      </div>
                    </div>
                    <ng-template #closed>
                      <div *ngFor="let stage of stageList">
                        <button mat-menu-item
                          *ngIf="stage.name=='won' || stage.name=='lost' && row?.lead_stage?.displayname !=='Won'"
                          (click)="updateLeadStage(row._id,stage._id)">
                          <span>
                            <span [ngClass]="{'bg-light-success badge badge-pill':stage.displayname == 'Won'}"
                              placement="top"
                              *ngIf="stage.displayname == 'Won' && row?.lead_stage?.displayname !=='Won'">{{stage.displayname}}</span>
                            <span [ngClass]="{'bg-light-danger badge badge-pill':stage.displayname == 'Lost'}"
                              placement="top" *ngIf="stage.displayname == 'Lost'">{{stage.displayname}}</span>
                          </span>
                        </button>
                      </div>
                    </ng-template>
                  </mat-menu>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl !=='training-leads'" name="Lead Stage" prop="lead_stage"
                [width]="50">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span
                    *ngIf="row?.leads?.lead_status?.name=='active'||row?.leads?.lead_status?.name=='closed';else lead_status"
                    placement="top" [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'"
                    [matMenuTriggerFor]="lead_stagemenu">
                    <span [ngClass]="{'bg-light-primary badge badge-pill':row?.leads?.lead_stage?.displayname == 'Hot'}"
                      placement="top" [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.leads?.lead_stage?.displayname == 'Hot'">{{row?.leads?.lead_stage?.displayname}}</span>
                    <span
                      [ngClass]="{'bg-light-success badge badge-pill':row?.leads?.lead_stage?.displayname == 'Nurture'}"
                      placement="top" [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.leads?.lead_stage?.displayname == 'Nurture'">{{row?.leads?.lead_stage?.displayname}}</span>
                    <span [ngClass]="{'bg-light-success badge badge-pill':row?.leads?.lead_stage?.displayname == 'Won'}"
                      placement="top" [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.leads?.lead_stage?.displayname == 'Won'">{{row?.leads?.lead_stage?.displayname}}</span>
                    <span [ngClass]="{'bg-light-danger badge badge-pill':row?.leads?.lead_stage?.displayname == 'Lost'}"
                      placement="top" [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.leads?.lead_stage?.displayname == 'Lost'">{{row?.leads?.lead_stage?.displayname}}</span>
                    <span
                      *ngIf="row?.leads?.lead_stage?.displayname !== 'Hot' && row?.leads?.lead_stage?.displayname !== 'Nurture' && row?.leads?.lead_stage?.displayname !== 'Won' && row?.leads?.lead_stage?.displayname !== 'Lost'"
                      placement="top"
                      [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'">{{row?.leads?.lead_stage?.displayname}}</span>
                  </span>

                  <ng-template #lead_status>

                    <span [ngClass]="{'bg-light-primary badge badge-pill':row?.leads?.lead_stage?.displayname == 'Hot'}"
                      placement="top" [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.leads?.lead_stage?.displayname == 'Hot'">{{row?.leads?.lead_stage?.displayname}}</span>
                    <span
                      [ngClass]="{'bg-light-success badge badge-pill':row?.leads?.lead_stage?.displayname == 'Nurture'}"
                      placement="top" [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.leads?.lead_stage?.displayname == 'Nurture'">{{row?.leads?.lead_stage?.displayname}}</span>
                    <span [ngClass]="{'bg-light-success badge badge-pill':row?.leads?.lead_stage?.displayname == 'Won'}"
                      placement="top" [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.leads?.lead_stage?.displayname == 'Won'">{{row?.leads?.lead_stage?.displayname}}</span>
                    <span [ngClass]="{'bg-light-danger badge badge-pill':row?.leads?.lead_stage?.displayname == 'Lost'}"
                      placement="top" [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'"
                      *ngIf="row?.leads?.lead_stage?.displayname == 'Lost'">{{row?.leads?.lead_stage?.displayname}}</span>
                    <span
                      *ngIf="row?.leads?.lead_stage?.displayname !== 'Hot' && row?.leads?.lead_stage?.displayname !== 'Nurture' && row?.leads?.lead_stage?.displayname !== 'Won' && row?.leads?.lead_stage?.displayname !== 'Lost'"
                      placement="top"
                      [ngbTooltip]="row?.leads?.last_activedate|date:'mediumDate'">{{row?.leads?.lead_stage?.displayname}}</span>
                  </ng-template>
                  <mat-menu #lead_stagemenu="matMenu">

                    <div *ngIf="row?.leads?.lead_status?.name=='active';else closed ">
                      <div *ngFor="let stage of stageList">
                        <button mat-menu-item *ngIf="stage.name=='nurture' || stage.name=='hot'"
                          (click)="updateLeadStage(row._id,stage._id)">
                          <span>
                            <span [ngClass]="{'bg-light-success badge badge-pill':stage.displayname == 'Nurture'}"
                              placement="top" *ngIf="stage.displayname == 'Nurture'">{{stage.displayname}}</span>
                            <span [ngClass]="{'bg-light-primary badge badge-pill':stage.displayname == 'Hot'}"
                              placement="top" *ngIf="stage.displayname == 'Hot'">{{stage.displayname}}</span>
                          </span>
                        </button>
                      </div>
                    </div>
                    <ng-template #closed>
                      <div *ngFor="let stage of stageList">
                        <button mat-menu-item
                          *ngIf="stage.name=='won' || stage.name=='lost' && row?.leads?.lead_stage?.displayname !=='Won' "
                          (click)="updateLeadStage(row._id,stage._id)">
                          <span>
                            <span [ngClass]="{'bg-light-success badge badge-pill':stage.displayname == 'Won'}"
                              placement="top"
                              *ngIf="stage.displayname == 'Won' && row?.leads?.lead_stage?.displayname !=='Won'">{{stage.displayname}}</span>
                            <span [ngClass]="{'bg-light-danger badge badge-pill':stage.displayname == 'Lost'}"
                              placement="top" *ngIf="stage.displayname == 'Lost'">{{stage.displayname}}</span>
                          </span>
                        </button>
                      </div>
                    </ng-template>
                  </mat-menu>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Actions" [width]="50"
                *ngIf="(user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor') && (currentUrl =='training-leads')">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span *ngIf="row?.action">
                    (<span [class.red-color]="row?.action?.displayname==('Call'||'Meeting')">{{row?.action?.displayname}}</span>)
                  </span>
                  <i *ngIf="!row?.action" mat-button [matMenuTriggerFor]="menu2"
                    class="ft-more-vertical text-primary cursor-pointer mr-2"></i><span
                    *ngIf="currentUrl =='training-leads' && row?.next_action?.displayname" class="cursor-pointer"
                    placement="top" [ngbTooltip]="row?.contact?.email ? row?.contact?.email :'email not available' "
                    (click)="openModal(myModalContent,row)">
                    (<span [class.red-color]="row?.next_action?.displayname==('Call'||'Meeting')">{{row?.next_action?.displayname}}</span>)
                  
                  </span>
                  <mat-menu #menu2="matMenu">
                    <button mat-menu-item (click)="editLeads(row)"><a><i class="ft-edit text-primary cursor-pointer mr-2">
                      Edit</i></a></button>
                    <button *ngIf="user_role.roles =='admin'" mat-menu-item (click)="Delete(row._id)"><i
                        class="ft-trash-2 cursor-pointer danger" (click)="Delete(row._id)"> Delete</i> </button>
                    <div *ngFor="let status of statusList">
                      <button mat-menu-item
                        *ngIf="status._id !== row?.lead_status?._id && showMoveTo(status,row?.lead_status)"
                        (click)="updateLeadStatus(row._id,status)"><i class=" cursor-pointer "
                          (click)="updateLeadStatus(row._id,status)"> Move To {{status.displayname}}</i> </button>
                    </div>
                  </mat-menu>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Actions" [width]="150"
                *ngIf="(user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor') && (currentUrl !=='training-leads')">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div>
                  <i mat-button [matMenuTriggerFor]="menu2"
                    class="ft-more-vertical text-primary cursor-pointer mr-2"></i><span
                    *ngIf="row?.leads?.next_action?.displayname" class="cursor-pointer"
                    (click)="openModal(myModalContent,row)">
                    <button class="btn btn-sm btn-outline-primary" [class.red-color]="row?.leads?.next_action?.displayname==('Call'||'Meeting')">{{row?.leads?.next_action?.displayname}}</button>
                  </span>
                  &nbsp;&nbsp; <span class="cursor-pointer" placement="top" ngbTooltip="Copy Link"
                    (click)="copyLink(row)"><i class="icon-link"></i></span>
                  &nbsp;&nbsp;<span class="badge badge-pill text-capitalize ng-star-inserted bg-light-primary" (click)="openLetter(myModalLetter,row)">Cover Letter</span>
                  <mat-menu #menu2="matMenu">
                    <button mat-menu-item (click)="editLeads(row)"><i class="ft-edit text-primary cursor-pointer mr-2">
                        Edit</i></button>
                    <button *ngIf="user_role.roles =='admin'" mat-menu-item (click)="Delete(row._id)"><i
                        class="ft-trash-2 cursor-pointer danger" (click)="Delete(row._id)"> Delete</i> </button>
                    <div *ngFor="let status of statusList">
                      <button mat-menu-item
                        *ngIf="status._id !== row?.leads?.lead_status?._id && showMoveTo(status,row?.leads?.lead_status)"
                        (click)="updateLeadStatus(row._id,status)"><i class=" cursor-pointer "
                          (click)="updateLeadStatus(row._id,status)"> Move To {{status.displayname}}</i> </button>
                    </div>
                    <button  mat-menu-item  (click)="openModal2(attachClientModal,row._id)">Attach Client </button>
                  </mat-menu>
                </div>
                <span [ngClass]="{
                  'bg-light-danger': row?.leads?.next_action?.displayname === 'Call' || row?.leads?.next_action?.displayname === 'Meeting',
                  'bg-light-secondary': row?.leads?.next_action?.displayname !== 'Call' && row?.leads?.next_action?.displayname !== 'Meeting'
                }"
                 class="badge badge-pill text-capitalize ng-star-inserted mt-2">{{row?.leads?.next_action_date | date:'mediumDate'}}<span *ngIf="row?.leads?.next_action_time"> | {{row?.leads?.next_action_time | convertTo12Hour}} </span></span>
                </ng-template>
              </ngx-datatable-column>


            </ngx-datatable>
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->
<!------------- Popup For Next_Action --------------------------------------->
<div>
  <ng-template #myModalContent>
    <div class="modal-header">
      <h4 class="modal-title">Next Activity</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Assign To</label>
        <ng-select
				  [items]="emp_list"
				  bindLabel="name"
				  bindValue="_id"
				  [closeOnSelect]="false"
				  placeholder="Select user"
				  [(ngModel)]="selected_emp"
          [multiple]="true"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getEmpId($event)"
				>
				</ng-select>
      </div>
      <div class="form-group">
        <label>Priority</label>
        <ng-select
				  [items]="priority_list"
				  bindLabel="name"
				  bindValue="name"
				  [closeOnSelect]="false"
				  placeholder="Select Priority"
				  [(ngModel)]="selected_priority"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getPriorityId($event)"
				>
				</ng-select>
      </div>
      <div class="form-group">
        <label>Next Action</label>
        <ng-select [items]="nextactionList" bindLabel="displayname" bindValue="_id" placeholder="Select next action"
          [(ngModel)]="lead.next_action" [ngModelOptions]="{standalone: true}" (change)="getChangeNextAction($event)">
        </ng-select>
      </div>
      <div class="form-group">
        <label>Next Action Date</label>
        <input class="form-control" type="date" [(ngModel)]="lead.next_action_date"
          [ngModel]="this.lead.next_action_date | date: 'yyyy-MM-dd'">
      </div>
      <div class="form-group">
        <label>Next Action Time</label>
        <input class="form-control" type="time" [(ngModel)]="lead.next_action_time"
          [ngModel]="this.lead.next_action_time">
      </div>
      <div class="form-group">
        <label>Notes</label>
        <textarea class="form-control" [(ngModel)]="lead.notes" name="notes" id="notes" cols="30" rows="2"></textarea>
      </div>
      <div class="form-group">
        <label>Last Active Date</label>
        <input class="form-control" type="date" [(ngModel)]="lead.last_activedate"
          [ngModel]="this.lead.last_activedate | date: 'yyyy-MM-dd'">
      </div>

      <div class="form-group">
        <label>Last Response</label>
        <!-- <input class="form-control" type="text" [(ngModel)]="lead.lastresponse"> -->
        <textarea class="form-control" [(ngModel)]="lead.lastresponse" name="lastresponse" id="lastresponse"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary task" (click)="updateTask()">Task Assign</button>
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
      <button type="button" class="btn btn-primary" (click)="updateLead()">Save changes</button>
    </div>
  </ng-template>
</div>
<!------------- Cover Letter Popup ------------------------>
<div>
  <ng-template #myModalLetter>
    <div class="modal-header">
      <h4 class="modal-title">Cover Letter</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <p [innerText]="cover_letter"></p>
      </div>
    </div>
   
  </ng-template>
</div>
<!-- ---- End ------------ -->
 <!-- Attach Client -->

 <div>
  <ng-template #attachClientModal>
    <div class="modal-header">
      <h4 class="modal-title">Attach Client</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Client</label>
        <ng-select
				  [items]="clients_list"
				  bindLabel="name"
				  bindValue="_id"
				  [closeOnSelect]="false"
				  placeholder="Select Client"
				  [(ngModel)]="selected_client"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getClientId($event)"
          [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true"
				>
				</ng-select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
      <button type="button" class="btn btn-primary" (click)="updateClient()">Submit</button>
    </div>
  </ng-template>
</div>

 <!-- ------- -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

